import React from "react";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormColorTC from "../../../components/Forms/FormColorTC";
import { GridLegacy } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";

export default function BlinkstickSettings() {
  return (
    <Card>
      <CardBody>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper
                tDefault={"Blinkstick settings"}
                tKey={"vestigingen.form.algemeen.headers.blinksticksettings"}
              />
            </h3>
          </GridLegacy>
          <FormControlledInputTC
            name={"extra_settings__blinkstick_settings.accessToken"}
            nullable
            tDefault={"Access token"}
            tKey={"blinkstick_settings.accessToken"}
          />
          <FormColorTC
            name={"extra_settings__blinkstick_settings.defaultStatusColor"}
            nullable
            tDefault={"Default color"}
            tKey={"blinkstick_settings.defaultStatusColor"}
          />
          <FormColorTC
            name={"extra_settings__blinkstick_settings.eancodeErrorColor"}
            nullable
            tDefault={"Eancode error color"}
            tKey={"blinkstick_settings.eancodeErrorColor"}
          />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}
